module.exports = __webpack_public_path__ + "img/map_pic.082042d7.png";